<et-step-layout [data]="data">
  @if (model) {
    <div>
      @if (isAbsentCopyright(model.copyrightStatus)) {
        <div>
          <et-paper-copyright-form [copyrightText]="model.copyrightText"
                                   [requestInProcess]="requestInProcess"
                                   [isReadonly]="isReadonly"
                                   (copyrightSubmitted)="acceptCopyright($event)">
          </et-paper-copyright-form>
        </div>
      } @else {
        <et-paper-copyright-download [fileInfo]="model.file"
                                     [download$]="download$">
        </et-paper-copyright-download>
      }
    </div>
  }
</et-step-layout>